export default __webpack_public_path__ + "static/blob6-20e4bc7e7991607717c9f7a98e22ddbb.svg";